import { PrivateInterceptor } from "../../../interceptors/PrivateInterceptor";
import { PublicInterceptor } from "../../../interceptors/PublicInterceptor";


export const getPublicAreas = async(token) => {
    const result = await PublicInterceptor('area', 'GET', {}, token)
    return result;
}

// OBTENER AREAS
export const getAreas = async () => {
    const respuesta = await PrivateInterceptor(`Base/Global/Areas`, "GET");
    return respuesta;
  };


// OBTENER AREAS
export const getAreasAct = async () => {
  const respuesta = await PrivateInterceptor(`Base/Global/Areas/AreasAct`, "GET");
  return respuesta;
};


// AGREGAR AREAS
export const addAreas = async (data) => {
  const respuesta = await PrivateInterceptor( `Base/Global/Areas/add`, "POST", data);
};

export const chageEstadoAreas = async (data) => {
  const result = await PrivateInterceptor(`Base/Global/Areas/chageEstadoAreas`, 'POST', data);
  return result;
}
